import React from 'react';
import { useRef } from 'react';
import { useState } from 'react';
import { PRINT_WIDTH } from '..';
import { fontReport } from '../../../../apis/util';
import { useEffect } from 'react';

export const Social = () => {
  const ref = useRef();
  const [width,setWidth] = useState(0)
  useEffect(() => {
    if (!ref.current) return; // wait for the elementRef to be available
    const resizeObserver = new ResizeObserver(() => {
      // Do what you want to do when the size of the element changes
      setWidth(ref.current.clientWidth)
    });
    resizeObserver.observe(ref.current);
    return () => resizeObserver.disconnect(); // clean up 
  }, []);
  return (
    <div className="social" ref={ref}>
      <h2 style={{ fontSize: fontReport(width,PRINT_WIDTH,51/PRINT_WIDTH,"px")}}>Social</h2>
    </div>
  );
};
